import cn from 'classnames'
import { Link } from 'react-router-dom'
import { ProfilePhoto } from 'components/ideal-core-ui'
import s from './ContactRow.scss'

const ContactRow = ({ contact }) => {
  const { id, photo, firstName, lastName, title } = contact
  return (
    <div className={s.contactRow}>
      <div className={s.rowItem}>
        <ProfilePhoto className={s.contactPhoto} src={photo} />
      </div>
      <div className={cn(s.rowItem, s.nameRow)}>
        <Link className={s.link} to={`/contacts/${id}`}>
          {firstName} {lastName}
        </Link>
      </div>
      <div className={cn(s.rowItem, s.titleRow)}>{title}</div>
    </div>
  )
}

export default ContactRow
